<template>
  <div
    class="main layout-manage"
  >
    <LayoutHeader/>

    <slot></slot> <!-- page content will be rendered instead of <slot></slot> -->
  </div>
</template>
<script>
import LayoutHeader from './header/'
export default {
  name: 'LayoutManage',
  components: {
    LayoutHeader
  }
}
</script>
